import { render, staticRenderFns } from "./modalGiayHenKhamLai.vue?vue&type=template&id=c61545fa"
import script from "./modalGiayHenKhamLai.vue?vue&type=script&lang=js"
export * from "./modalGiayHenKhamLai.vue?vue&type=script&lang=js"
import style0 from "./modalGiayHenKhamLai.vue?vue&type=style&index=0&id=c61545fa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports